module.exports = __webpack_public_path__ + "static/Muli-Italic-c9ba6493c5d782b51d091d9caf4700bc.ttf";